const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#143980',
                hover: '#0F2E69'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
